import { Component, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Router, RouterOutlet } from '@angular/router';
import { BannerComponent, LogoComponent } from '@roomex/rx-components';
import { layoutWithBannerRoutes } from '../constants/banner-layout-routes';

@Component({
  selector: 'rx-applications-shared-auth-feature-shell',
  standalone: true,
  imports: [CommonModule, RouterOutlet, LogoComponent, BannerComponent],
  templateUrl: './shared-auth-feature-shell.component.html',
  styleUrls: ['./shared-auth-feature-shell.component.scss'],
})
export class SharedAuthFeatureShellComponent {
  router: Router = inject(Router);

  get isLayoutWithBanner(): boolean {
    const currentPath: string = this.router.url.split('?')[0];
    return layoutWithBannerRoutes.some((route) => currentPath.includes(route));
  }
}
